import { render, staticRenderFns } from "./FourthShow.vue?vue&type=template&id=a925dd28&scoped=true"
import script from "./FourthShow.vue?vue&type=script&lang=js"
export * from "./FourthShow.vue?vue&type=script&lang=js"
import style0 from "./FourthShow.vue?vue&type=style&index=0&id=a925dd28&prod&lang=less&scoped=true"
import style1 from "./FourthShow.vue?vue&type=style&index=1&id=a925dd28&prod&scoped=true&lang=css"
import style2 from "./FourthShow.vue?vue&type=style&index=2&id=a925dd28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a925dd28",
  null
  
)

export default component.exports